import { getJSON } from '@/lib/api'
import type { ActivityRetentionYears } from './activityRetention'

// Read-only API contract: GET /api/v1/connections/:id/retention_preview (#3178).
export const retentionPreviewRows = [
  { key: 'attendees', label: 'Event registrations' },
  { key: 'order_items', label: 'Order lines' },
  { key: 'enrolments', label: 'Course enrolments' },
  { key: 'email_sends', label: 'Email sends' },
  { key: 'email_clicks', label: 'Email clicks' },
  { key: 'events', label: 'Events left empty' },
  { key: 'event_orders', label: 'Orders left empty' },
  { key: 'courses', label: 'Courses left empty' },
] as const
export type RetentionPreviewCounts = Record<(typeof retentionPreviewRows)[number]['key'], number>
export type RetentionPreviewResponse = {
  retention_preview: {
    activity_retention_years: Exclude<ActivityRetentionYears, null>
    counts: RetentionPreviewCounts
  }
}

export async function readRetentionPreview(id: number, years: ActivityRetentionYears) {
  const result = await getJSON<RetentionPreviewResponse>(
    `/api/v1/connections/${id}/retention_preview?activity_retention_years=${years}`,
  )
  const preview = result?.retention_preview
  if (preview?.activity_retention_years !== years || !validCounts(preview?.counts))
    throw new Error('Retention preview is unavailable. Try again.')
  return preview.counts
}
function validCounts(counts: RetentionPreviewCounts | undefined) {
  return (
    !!counts &&
    retentionPreviewRows.every(({ key }) => Number.isSafeInteger(counts[key]) && counts[key] >= 0)
  )
}
